import { Condition, ConditionParams } from './types';

export default function checkStepCondition(
  condition: Condition,
  state: ConditionParams
) {
  if (!condition) {
    return true;
  }
  if (Array.isArray(condition)) {
    return condition.some((elem) => elem(state));
  }
  return condition(state);
}
